/**
 * Team carousel Block JavaScript
 *
 * Handles:
 * - Splide carousel initialization
 * - Inline video playback (play inside card)
 * - Popup/modal video playback (autoplay on modal open)
 *
 * @package TekCreative
 * @since 2.0.0
 */

import SplideCarousel from '../../../../javascript/components/splide.js';

(function() {
    'use strict';

    const FourColTeam001 = {
        selector: '.four-col-team-001',

        init() {
            const blocks = document.querySelectorAll(this.selector);
            if (!blocks.length) return;

            blocks.forEach(block => this.initBlock(block));
            this.initModals();
        },

        initBlock(block) {
            if (block.dataset.initialized === 'true') return;
            block.dataset.initialized = 'true';

            this.initCarousel(block);
        },

        initCarousel(block) {
            const sliders = block.querySelectorAll('.splide-carousel');
            sliders.forEach(slider => {
                SplideCarousel.init(slider);
            });
        },

        initModals() {
            const modals = document.querySelectorAll('.four-col-team-001__modal');

            modals.forEach((modal) => {
                const modalVideo = modal.querySelector('video');
                if (!modalVideo) return;

                const playVideo = () => {
                    modalVideo.currentTime = 0;
                    const p = modalVideo.play();
                    if (p !== undefined) {
                        p.catch(() => {});
                    }
                };

                const stopVideo = () => {
                    modalVideo.pause();
                    modalVideo.currentTime = 0;
                };

                // Listen for custom modal events
                modal.addEventListener('modal:open', playVideo);
                modal.addEventListener('modal:close', stopVideo);

                // Observe class/attribute changes
                const observer = new MutationObserver(() => {
                    const isOpen = modal.classList.contains('is-open') ||
                                   modal.getAttribute('aria-hidden') === 'false';
                    if (isOpen) {
                        playVideo();
                    } else {
                        stopVideo();
                    }
                });

                observer.observe(modal, {
                    attributes: true,
                    attributeFilter: ['class', 'aria-hidden', 'style'],
                });
            });
        },
    };

    // Global document-level click delegation for video triggers
    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.four-col-team-001 [data-video-trigger]');
        if (!trigger) return;

        const card = trigger.closest('[data-video-card]');
        if (!card) return;

        const mode = card.dataset.videoMode || 'popup';

        if (mode === 'card' || mode === 'inside') {
            e.preventDefault();
            e.stopPropagation();

            const playerWrap = card.querySelector('.four-col-team-001__video-player-wrap');
            const player     = card.querySelector('.four-col-team-001__video-player');

            if (playerWrap && player) {
                trigger.style.display = 'none';
                playerWrap.style.display = 'block';

                const playPromise = player.play();
                if (playPromise !== undefined) {
                    playPromise.catch(() => {});
                }
            }

        } else if (mode === 'popup') {
            const modalId = card.dataset.modalTarget || trigger.dataset.modalTarget;
            if (!modalId) return;

            // Trigger modal open via TC.Modal API if available
            if (window.TC && window.TC.Modal && typeof window.TC.Modal.open === 'function') {
                window.TC.Modal.open(modalId);
            }

            const modal = document.getElementById(modalId);
            if (modal) {
                const modalVideo = modal.querySelector('video');
                if (modalVideo) {
                    const playVideo = () => {
                        modalVideo.currentTime = 0;
                        const p = modalVideo.play();
                        if (p !== undefined) {
                            p.catch(() => {});
                        }
                    };

                    playVideo();
                    setTimeout(playVideo, 100);
                    setTimeout(playVideo, 300);
                }
            }
        }
    });

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => FourColTeam001.init());
    } else {
        FourColTeam001.init();
    }

    // Re-initialize for Gutenberg editor preview
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=four-col-team-001', () => {
            setTimeout(() => FourColTeam001.init(), 100);
        });
    }

})();
